import React from 'react';
import {Box, styled} from '@mui/material';
import {designSystemToken, Body} from '@lightricks/react-design-system';

export interface TagBannerProps {
  text: string;
  icon?: JSX.Element;
  color?: string;
}

const StyledTag = styled(Box)(() => ({
  position: 'absolute',
  top: '14px',
  right: '14px',
  backgroundColor: designSystemToken('semantic.bg.primary'),
  borderRadius: '3px',
  padding: '10px 12px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  zIndex: 1,
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
}));

const StyledBody = styled(Body)(() => ({
  fontSize: '13px',
}));

export function TagBanner(props: TagBannerProps) {
  const {text, icon, color = designSystemToken('semantic.fg.primary')} = props;
  return (
    <StyledTag>
      {icon || null}
      <StyledBody size="sm" color={color}>
        {text}
      </StyledBody>
    </StyledTag>
  );
}
